export default "__VITE_ASSET__59658acb__"